var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"contain":"","height":"24px","width":"24px","src":require("@/assets/discord.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }